import { apiSlice } from "../../app/api/apiSlice"
import { generateFormatedURL } from "../../utils/urlFormatter"

export const companyApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCompanyById: builder.query({
            query: (id) => `/Company/${id}`,
        }),

        getCompanyListing: builder.query({
            query: (args) => `/Company`.concat(generateFormatedURL(args)),
        }),

        createCompany: builder.mutation({
            query: (body) => ({
                url: '/Company',
                method: 'POST',
                body: { ...body },
            })
        }),

        updateCompany: builder.mutation({
            query: (body) => ({
                url: `/Company/${body?.id}`,
                method: 'PUT',
                body: { ...body },
            })
        }),

        getCompanyDropDownList: builder.query({
            query: () => `/Company/dropdownlist`
        }),
    })
})

export const {
    useLazyGetCompanyByIdQuery,
    useLazyGetCompanyListingQuery,
    useCreateCompanyMutation,
    useUpdateCompanyMutation,
    useLazyGetCompanyDropDownListQuery,
} = companyApiSlice  